export enum BREADCRUMB_PAGE {
  HOME = "HOME",
  WELLNESS_RESOURCE = "WELLNESS_RESOURCE",
  RESOURCE = "RESOURCE",
  FEEDBACK_GUIDE = "FEEDBACK_GUIDE",
  FEEDBACK_PORTAL = "FEEDBACK_PORTAL",
  FEEDBACK = "FEEDBACK",
  FEEDBACK_ORGANIZATION = "FEEDBACK_ORGANIZATION",
  EPA_DETAIL = "EPA_DETAIL",
  COMPETENCY_DETAIL = "COMPETENCY_DETAIL",
  GRADUATION_CLASS = "GRADUATION_CLASS",
  YEARLY_CURRICULUM = "YEARLY_CURRICULUM",
  ACADEMIC_YEAR = "ACADEMIC_YEAR",
  SITES = "SITES",
  ORGANIZATION = "ORGANIZATION",
  ORGANIZATION_REQUIREMENT_EPAS = "ORGANIZATION_REQUIREMENT_EPAS",
  ORGANIZATION_REQUIREMENT_COMPETENCIES = "ORGANIZATION_REQUIREMENT_COMPETENCIES",
  ORGANIZATION_REQUIREMENT_ITERS = "ORGANIZATION_REQUIREMENT_ITERS",
  ITER_LIST = "ITER_LIST",
  BACK = "BACK",
  REQUIREMENT_PORTAL = "REQUIREMENT_PORTAL",
  USER = "USER",
  ONBOARDING = "ONBOARDING",
  ORGANIZATION_LEARNERS = "ORGANIZATION_LEARNERS",
  LEARNERS = "LEARNERS",
  SURVEY_CREATE_AND_EDIT = "SURVEY_CREATE_AND_EDIT",
  ORGANIZATION_SURVEY_CREATE_AND_EDIT = "ORGANIZATION_SURVEY_CREATE_AND_EDIT",
}
